import React from "react";
import HeroSection from "../../components/Habitacional/HeroSection";

import Banner from "../../assets/images/home/hero-desktop.png";
import BannerMobile from "../../assets/images/home/hero-mobile.png";
import BannerAlert from "../../components/Habitacional/BannerAlert";
import HealthSection from "./components/HealthSection";
import HousingSection from "./components/HousingSection/HousingSection";
import BusinessSection from "./components/BusinessSection";
import ResidentialSection from "./components/ResidentialSection";
import AutoSection from "./components/AutoSection";
import FooterHabitacional from "../../components/Habitacional/core/Footer";
import Header from "../../components/layouts/RunOff/header";

const Home = () => {
  return (
    <main style={{ backgroundColor: "#EDF4F6" }}>
      <Header />
      <HeroSection
        backgroundImageDesktop={Banner}
        backgroundImageMobile={BannerMobile}
        mainTitle="Caixa Seguradora"
        secondaryTitle="Sempre cuidando das suas conquistas"
      />

      <BannerAlert
        mainTitle="A facilidade para acionar o seguro está aqui!"
        mainText={
          <div style={{ marginTop: "32px" }}>
            Com alguns cliques, faça o pedido de indenização do Seguro
            Habitacional e acompanhe tudo pelo site. É simples, prático e
            confiável. Tudo isso para oferecer a tranquilidade e o cuidado que
            você e sua família merecem. Para iniciar, clique no botão ‘Acionar o
            seguro’ logo abaixo.
          </div>
        }
      />

      <HousingSection />
      <BusinessSection />
      <ResidentialSection />
      <AutoSection />
      <HealthSection />
      <FooterHabitacional />
    </main>
  );
};

Home.propTypes = {};

export default Home;
